import React from 'react';

const taskIcon = type => `/ats/icons/${type.replace(/_/g, '-')}-icon.svg`;

const theme = (
	className,
	type,
	accent,
	cardBg,
	cardBorder,
	tagBg = '#FFFFFF'
) => ({
	className,
	icon: taskIcon(type),
	accent,
	cardBg,
	cardBorder,
	tagBg
});

export const jobApplicationTaskThemes = {
	candidate_submission: theme(
		'is-candidate-submission',
		'candidate_submission',
		'#4E5BA6',
		'#F8F9FC',
		'#C8CCE5'
	),
	client_interview: theme(
		'is-client-interview',
		'client_interview',
		'#717BBC',
		'#FCFCFD',
		'#C8CCE5',
		'#FFFFFF'
	),
	client_assessment: theme(
		'is-client-assessment',
		'client_assessment',
		'#7A5AF8',
		'#F4F3FF',
		'#D9D6FE'
	),
	pre_hiring_session: theme(
		'is-pre-hiring-session',
		'pre_hiring_session',
		'#F79009',
		'#FFFAEB',
		'#FEF0C7'
	),
	hiring_request: theme(
		'is-hiring-request',
		'hiring_request',
		'#F63D68',
		'#FEF3F2',
		'#FECDCA'
	),
	verbal_offer: theme(
		'is-verbal-offer',
		'verbal_offer',
		'#9B8AFB',
		'#F4F3FF',
		'#D9D6FE'
	),
	offer_letter: theme(
		'is-offer-letter',
		'offer_letter',
		'#079455',
		'#ECFDF3',
		'#ABEFC6'
	),
	placement: theme(
		'is-placement',
		'placement',
		'#34D3B3',
		'#F0FDF9',
		'#99F6E0'
	),
	onboarding_request: theme(
		'is-onboarding-request',
		'onboarding_request',
		'#4E5BA6',
		'#F8F9FC',
		'#C8CCE5',
		'#F8F9FC'
	),
	note: theme('is-note', 'note', '#414651', '#FCFCFD', '#EAECF5')
};

const defaultTheme = jobApplicationTaskThemes.note;

export const getJobApplicationTaskTheme = type =>
	jobApplicationTaskThemes[type] || defaultTheme;

const jobActivityTaskStatusIcons = {
	pending: '/ats/icons/task-pending-badge-icon.svg',
	cancelled: '/ats/icons/task-cancelled-badge-icon.svg',
	completed: '/ats/icons/task-completed-badge-icon.svg'
};

export const getJobActivityTaskStatusIcon = status =>
	jobActivityTaskStatusIcons[status] || `/ats/icons/task-${status}-icon.svg`;

export const renderJobApplicationTaskTypeLabel = (label, type) => {
	const taskTheme = getJobApplicationTaskTheme(type);

	return (
		<span
			className="job-task-dropdown-option"
			style={{ color: taskTheme.accent }}>
			<img src={taskTheme.icon} alt="" />
			{label}
		</span>
	);
};

export const getJobApplicationTaskDropdownOptions = taskOptions =>
	taskOptions.map(task => {
		const taskTheme = getJobApplicationTaskTheme(task.value);

		return {
			...task,
			text: task.label,
			className: `job-task-dropdown-item ${taskTheme.className}`,
			label: renderJobApplicationTaskTypeLabel(task.label, task.value)
		};
	});
